import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { User } from '@models/user';
//import { AlertifyService } from '../services/alertify.service';
import { AlertifyService } from '@services/alertify.service';

import { AuthService } from '@services/auth.service';
import { AdminSettingsService } from '@core/services/admin-settings.service';
import { Router } from '@angular/router';
import { Country } from '@models/country';
import { CountryService } from '@services/country.service';

import { faFilm } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { CustomValidators } from '@app/shared/validators/custom.validators';
// import { MyErrorStateMatcher } from '../shared/my_error_state_matcher';
import {  RxReactiveFormsModule } from "@rxweb/reactive-form-validators"
import { state } from '@angular/animations';
import { State } from '@popperjs/core';
import { TranslateService } from '@ngx-translate/core';
import { Bootstrap_Modal_Service } from '@services/bootstrap-modal.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css' ]
})
export class RegisterComponent implements OnInit {
  // fa
  filmIcon = faFilm;
  faEnvelopeIcon = faEnvelope;

  registerForm: FormGroup;
  //emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  // ...existing code...
  emailPattern = '^[a-zA-Z0-9](?:[a-zA-Z0-9.-]*[a-zA-Z0-9])?@[a-zA-Z0-9-]{1,}(?:\\.[a-zA-Z0-9-]+)*\\.[a-zA-Z]{2,}$';

  user: User;
  countries: Country[];
  states: State[];
  usStates: { code: string, name: string }[] = [];
  isUSSelected = false;
  // matcher = new MyErrorStateMatcher();
  defaultCountry = 'US';
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;
  
  // Registration restriction properties
  isRegistrationRestricted: boolean = false;
  isCheckingRestriction: boolean = true;

  // Instantiate the Component
  constructor(
    private alertify: AlertifyService,
    private fb: FormBuilder, 
    private authService: AuthService, 
    private countryService: CountryService,
    private adminSettingsService: AdminSettingsService,
    private router: Router,
    private translate: TranslateService,
    private bootstrap_modal: Bootstrap_Modal_Service
  ) { }

  // Initialize the Component 
  ngOnInit() {
    this.createRegisterForm();
    this.checkRegistrationRestriction();
    this.getCountryList();
    this.getStatesList();
    this.initializeUSStates();
    this.setupCountryChangeListener();
  }

  checkRegistrationRestriction() {
    // console.log('Starting registration restriction check');
    this.isCheckingRestriction = true;
    
    // Add a fallback timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      console.warn('Registration restriction check timed out - allowing registration');
      this.isCheckingRestriction = false;
      this.isRegistrationRestricted = false;
      this.enableRegistrationForm(); // Re-enable form if timeout occurs
    }, 10000); // 10 second timeout

    try {
      // console.log('Calling adminSettingsService.isRegistrationRestricted()');
      this.adminSettingsService.isRegistrationRestricted().subscribe({
        next: (isRestricted) => {
          // console.log('Received registration restriction response:', isRestricted);
          clearTimeout(timeoutId);
          console.log('Registration restriction result:', isRestricted);
          this.isRegistrationRestricted = isRestricted;
          this.isCheckingRestriction = false;
          
          if (isRestricted) {
            // Disable the form if registration is restricted
            this.disableRegistrationForm();
          } else {
            // Re-enable the form if registration is allowed
            this.enableRegistrationForm();
          }
        },
        error: (error) => {
          clearTimeout(timeoutId);
          console.error('Error checking registration restriction:', error);
          this.isCheckingRestriction = false;
          // Allow registration if error checking setting
          this.isRegistrationRestricted = false;
          this.enableRegistrationForm(); // Re-enable form on error
        }
      });
    } catch (error) {
      clearTimeout(timeoutId);
      console.error('Exception in checkRegistrationRestriction:', error);
      this.isCheckingRestriction = false;
      this.isRegistrationRestricted = false;
      this.enableRegistrationForm(); // Re-enable form on exception
    }
  }

  disableRegistrationForm() {
    console.log('Disabling registration form');
    if (this.registerForm) {
      this.registerForm.disable();
    }
  }

  enableRegistrationForm() {
    console.log('Enabling registration form');
    if (this.registerForm) {
      this.registerForm.enable();
    }
  }

  initializeUSStates() {
    this.usStates = [
      { code: 'AL', name: 'Alabama' },
      { code: 'AK', name: 'Alaska' },
      { code: 'AZ', name: 'Arizona' },
      { code: 'AR', name: 'Arkansas' },
      { code: 'CA', name: 'California' },
      { code: 'CO', name: 'Colorado' },
      { code: 'CT', name: 'Connecticut' },
      { code: 'DE', name: 'Delaware' },
      { code: 'FL', name: 'Florida' },
      { code: 'GA', name: 'Georgia' },
      { code: 'HI', name: 'Hawaii' },
      { code: 'ID', name: 'Idaho' },
      { code: 'IL', name: 'Illinois' },
      { code: 'IN', name: 'Indiana' },
      { code: 'IA', name: 'Iowa' },
      { code: 'KS', name: 'Kansas' },
      { code: 'KY', name: 'Kentucky' },
      { code: 'LA', name: 'Louisiana' },
      { code: 'ME', name: 'Maine' },
      { code: 'MD', name: 'Maryland' },
      { code: 'MA', name: 'Massachusetts' },
      { code: 'MI', name: 'Michigan' },
      { code: 'MN', name: 'Minnesota' },
      { code: 'MS', name: 'Mississippi' },
      { code: 'MO', name: 'Missouri' },
      { code: 'MT', name: 'Montana' },
      { code: 'NE', name: 'Nebraska' },
      { code: 'NV', name: 'Nevada' },
      { code: 'NH', name: 'New Hampshire' },
      { code: 'NJ', name: 'New Jersey' },
      { code: 'NM', name: 'New Mexico' },
      { code: 'NY', name: 'New York' },
      { code: 'NC', name: 'North Carolina' },
      { code: 'ND', name: 'North Dakota' },
      { code: 'OH', name: 'Ohio' },
      { code: 'OK', name: 'Oklahoma' },
      { code: 'OR', name: 'Oregon' },
      { code: 'PA', name: 'Pennsylvania' },
      { code: 'RI', name: 'Rhode Island' },
      { code: 'SC', name: 'South Carolina' },
      { code: 'SD', name: 'South Dakota' },
      { code: 'TN', name: 'Tennessee' },
      { code: 'TX', name: 'Texas' },
      { code: 'UT', name: 'Utah' },
      { code: 'VT', name: 'Vermont' },
      { code: 'VA', name: 'Virginia' },
      { code: 'WA', name: 'Washington' },
      { code: 'WV', name: 'West Virginia' },
      { code: 'WI', name: 'Wisconsin' },
      { code: 'WY', name: 'Wyoming' },
      { code: 'DC', name: 'District of Columbia' }
    ];
  }

  setupCountryChangeListener() {
    this.registerForm.get('countryId')?.valueChanges.subscribe(countryId => {
      this.isUSSelected = countryId === 'US';
      // Clear the state field when country changes
      this.registerForm.get('state')?.setValue('');
    });
  }

createRegisterForm() {
  this.registerForm = this.fb.group({
    lwccMember: ['No'],
    firstname: ['', Validators.required],
    lastname: ['', Validators.required],
    email: ['', [Validators.required, Validators.pattern(this.emailPattern)]], 
    countryId: ['', Validators.required],
    city: ['', Validators.required],
    state: ['', Validators.required],
    password: ['', [
      Validators.required, 
      Validators.minLength(4), // Match your backend validation
      Validators.maxLength(100),
      this.mixedCaseValidator
    ]],
    confirmPassword: ['', [
      Validators.required, 
      Validators.minLength(4), 
      Validators.maxLength(100)
    ]],
  }, { validator: CustomValidators.compareTwoPasswords });
}

mixedCaseValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  
  const hasLowerCase = /[a-z]/.test(control.value);
  const hasUpperCase = /[A-Z]/.test(control.value);
  
  if (!hasLowerCase || !hasUpperCase) {
    return { mixedCase: true };
  }
  
  return null;
}

//   buildForm(): void {
//     this.userForm = this.formBuilder.group({
//         passwords: this.formBuilder.group({
//             password: ['', [Validators.required]],
//             confirm_password: ['', [Validators.required]],
//         }, {validator: this.passwordConfirming}),

//     });
// }

  register() {
    // Check if registration is restricted
    if (this.isRegistrationRestricted) {
      this.translate.get(["ALERTIFY.REGISTER_DISABLED_BY_ADMIN", "BOOTSTRAP.MODAL.ERROR"]).subscribe((text: string) => {

        this.alertify.error(text)

        this.bootstrap_modal.open({
          modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
          modal_body_html: text['ALERTIFY.REGISTER_DISABLED_BY_ADMIN'],
          modal_color_variant: "danger"
        })

      })
      return
    }
    
    if (this.registerForm.valid) {
      // move the vslues from this.registerForm.value to {}
      this.user = (<any>Object).assign({}, this.registerForm.value);      
      this.user.lwccMember = this.user.lwccMember === "Yes" //convert to bool.

      this.authService.register(this.user).subscribe(() => {
        this.translate.get(["ALERTIFY.REGISTER_SUCCESSFUL", "ALERTIFY.SUBMITTED_INFORMATION", "BOOTSTRAP.MODAL.SUCCESS"]).subscribe((text: string) => {
          this.alertify.success(text['ALERTIFY.REGISTER_SUCCESSFUL'])

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.SUCCESS'],
            modal_body_html: `
              <b>${text['ALERTIFY.SUBMITTED_INFORMATION']}.</b>
              <ul class="list-group mt-3 text-start">
                <li class="list-group-item">First Name: ${this.user.firstname}</li>
                <li class="list-group-item">Last Name: ${this.user.lastname}</li>
                <li class="list-group-item">Email: ${this.user.email}</li>
                <li class="list-group-item">Country: ${this.user.countryId}</li>
                <li class="list-group-item">State: ${this.user.state}</li>
                <li class="list-group-item">City: ${this.user.city}</li>
                <li class="list-group-item">LWCC Member: ${this.user.lwccMember ? 'Yes' : 'No'}</li>
              </ul>
            `,
            modal_color_variant: "success"
          })
        })
        this.router.navigate(['message-signup']);
      }, error => {
        console.log(error)
        this.translate.get(["ALERTIFY.REGISTER_FAILED", "BOOTSTRAP.MODAL.ERROR", "ALERTIFY.REASON"]).subscribe((text: string) => {          

          let html = `
              <b>${text['ALERTIFY.REGISTER_FAILED'].toUpperCase()}.</b>
              <ul class="list-group mt-3 text-start">
                <li class="list-group-item">${text['ALERTIFY.REASON']}: ${error.toUpperCase()}</li>
              </ul>
          `

          this.alertify.error(html)

          this.bootstrap_modal.open({
            modal_header_html: text['BOOTSTRAP.MODAL.ERROR'],
            modal_body_html: html,
            modal_color_variant: "danger"
          })
        })
      }, () => { // third part , complete, we nee to redirect the user once they have register
          this.router.navigate(['message-signup']);
      });
    }
  }

  getCountryList() {
    console.log('getCountryList');
    this.countryService.getCountriesList().subscribe((countries: Country[]) => {
      this.countries = countries;
      // console.log("Get Countries List: ", this.countries);
    }, error => {
      this.alertify.error(error);
    }, () => { // third part , complete
        //set default country
        this.registerForm.controls['countryId'].setValue('US');
        this.isUSSelected = true; // Set initial state since US is default
    }
    );
  }

  getStatesList() {
    this.countryService.getStatesList().subscribe((states: State[]) => {
      this.states = states;
      // console.log("Get States List: ", this.states);
    }, error => {
      this.alertify.error(error);
      }
    );
  }

}
